const INITIAL_STATE = {
    name: null,
    email: null,
    contact: null,
    speciality: null,
    pass: null,
    errorCreateUser: null,
    successCreateUser: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'SUBMIT_FORM_FREETRIAL_SUCESS':
        const user = {
          email: action.acvalues.email,
          pass: action.payload.result.password
        };
    
        return {
          ...state,
          email: user.email,
          pass: user.pass,
          errorCreateUser: null,
          successCreateUser: true         
        };
      case 'SUBMIT_FORM_FREETRIAL_ERROR':
        //ERROR: EMAIL ALREADY EXISTS. 
        if (action.payload.data.applicationMessages.length > 0 && action.payload.data.applicationMessages[0] == "ERROR: EMAIL ALREADY EXISTS. ") {
          return {
              ...state,
              email: "",
              pass: "",
              errorCreateUser: "error_user_exists",
              successCreateUser: false
          };
        } else {
          return {
            ...state,
            email: "",
            pass: "",
            errorCreateUser: action.payload.data.applicationMessages.length > 0 ? action.payload.data.applicationMessages[0] : "error_create_user",
            successCreateUser: false
          };
        }
        
      case 'SET_LOADING':
        return {
          ...state,
          isLoading: action.isLoading
        };
     
      default:
        return state;
    }
  };